














import Vue from 'vue';
export default Vue.extend({
  name: 'HMEmpty',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: { type: String, required: true },
    image: {
      type: String,
      default: 'empty-orders',
    },
    imageSize: {
      type: String,
    },
  },
});
